
$('document').ready(function() {

    setTimeout(function() {
        $.get('/a', {
            koszykIlosc: 1
        }, function(data) {
            $("#amountInCart").html(data);
        });
    }, 500);
    $(".header-basket.link").hover(function() {
        $.get('/a', {
            koszykHtml: 1
        }, function(data) {
            $(".cart-items").html(data);
        });
    });
    $(".header-login").click(function() {
        $.get('/a', {
            panelKlienta: 1
        }, function(data) {
            $(".header-login__wrapper").html(data);
        });
    });

    $(".form-input-onchange input").on("change", function(){
        $(this).parents("form").submit();      
    })
    $(".select-onchange").on("change", function(){
        $(this).parents("form").submit();      
    })

    $(".select-goToUrl").on("change", function(){
        let hrefUrl=$(this).val();      
       window.location.href=hrefUrl;
    })

});